import { PieceType, PieceState, SET_NEXT_PIECE, SET_INNER_PIECE, SET_LOOP_VARIABLE, SET_ITERABLE_VARIABLE, SET_OPERAND, SET_LEFT_OPERAND, SET_RIGHT_OPERAND, SET_MEMBER_VARIABLE, SET_DATA_STORE_VALUE, SET_DATA_SET_VALUE, SET_DATA_COPY_VARIABLE, SET_RETURN_VALUE, SET_QUESTION_DATA, SET_CONDITION_PIECE, SET_CONDITION_NEXT_PIECE, SET_CONDITION_PIECE_POSITION, SET_CONDITION_PIECES, START_PIECE_DRAG, STOP_PIECE_DRAG, SET_TARGET_PIECE, SET_UPDATE_STATUS_VALUE, SET_CUSTOM_FIELD, SET_VARIABLE_FOR_SET, UPDATE_VARIABLE_PIECE, ADD_PIECE, AllPieceTypes, SET_SELECTED_OPTIONS, SET_VARIABLE_FOR_SHOW, SET_ENTITY_TYPE, SET_CUSTOM_FIELDS_FOR_SHOW, DELETE_PIECE, COPY_PIECE, SET_WORKFLOW, SET_WORKFLOW_TYPE, SET_WORKFLOW_STATUS, SET_WORKFLOW_DUE_DATE, SET_WORKFLOW_AFFILIATION_VARIABLE, SET_WORKFLOW_IS_ASYNC, SET_TRANSFER_ROLES, UPDATE_CUSTOM_FIELD_PIECE, SET_VARIABLE_FOR_CUSTOM_FIELD, SET_UPDATE_DUE_DATE_VALUE, SET_ERROR, UPDATE_ANSWER_PIECE, UPDATE_STATUS_PIECE, ADD_FULL_PIECE, ADD_FULL_PIECES, SET_QUESTION_REQUIRED_PIECE, SET_QUESTION_DISABLED_PIECE, SET_VARIABLE_FOR_ADD_MEMBER, SET_VARIABLE_FOR_ADD_GROUP, SET_VARIABLE_FOR_ADD_WORKFLOW, SET_LOCATION_PIECE, SET_VARIABLE_FOR_LIST, SET_VARIABLE_FOR_NEW_DATE, SET_PIECE_FOR_LIST, SET_QUESTION_CHOICE_VARIABLE, SET_MEMBERS_TYPE_IN_GROUP, SET_VARIABLE_PIECE, SET_HEADING, SET_COLUMNS, SET_STRUCTURE_PROJECT, SET_STRUCTURE_LEVEL, SET_STRUCTURE_ROLE, SET_QUESTION_DEFAULT_PIECE, SET_YEAR, SET_MONTH, SET_DATE, SET_MESSAGE, SET_REPORT_NAME, SET_REPORT_TYPE, SET_REPORT_USER, SET_REPORT_START_DATE, SET_REPORT_END_DATE, SET_VARIABLE_FOR_ADD_REPORT, IPiece, UPDATE_PIECES_DATA, SYNCHRONIZE_PIECES_DATA, CLEAR_PIECES_DELTA, SET_QUESTION_IMAGE, SET_RICH_TEXT_FOR_SHOW, SET_FORMAT_MODIFIER, SET_TIME_DIFFERENCE_FORMAT, SHOW_RICH_TEXT_EDITOR, HIDE_RICH_TEXT_EDITOR, SET_VARIABLE_FOR_CURRENT_LOCATION, SET_STATIC_DATA_HOLDER, SET_DATA_FRAGMENTS, SET_STARTING_DISPLAY_FOR_SHOW, SET_X_AXIS_FOR_SHOW, SET_Y_AXIS_FOR_SHOW, SET_Y_AXIS_AGGREGATION_FOR_SHOW, SET_WIDGET_TITLE_FOR_SHOW, SET_WORKFLOW_SHOW_ERRORS, SET_ENTITY } from './types';
import { UPDATE_FLOWCHART_DATA, FlowchartActionTypes } from '../types';
import { updateEntries, synchronizeEntries, clearDelta } from '../../normalized-model';

export const initialState: PieceState = {
    byId: {},
    allEntries: [],
    filteredEntries: [],

    createdIds: new Set<string>(),
    updatedIds: new Set<string>(),
    deletedIds: new Set<string>(),

    isDragging: false,
    lastDraggedPiece: undefined,
    lastCopiedPiece: undefined,
    targetPiece: undefined,

    isShowingRichTextEditor: false,
}

export function piecesReducer(state = initialState, action: FlowchartActionTypes) : PieceState {
    let newPieceData;
    
    switch(action.type) {
        case SET_NEXT_PIECE:

            newPieceData = {
                ...state.byId[action.pieceId]
            };

            switch (newPieceData.type) {
                case PieceType.START:
                case PieceType.FOR:
                case PieceType.QUESTION:
                case PieceType.CHOICE:
                case PieceType.STORE:
                case PieceType.GET:
                case PieceType.SET_VARIABLE:
                case PieceType.UPDATE_STATUS:
                case PieceType.UPDATE_DUE_DATE:
                case PieceType.SPLIT:
                case PieceType.SHOW:
                case PieceType.START_WORKFLOW:
                case PieceType.SWITCH_WORKFLOW:
                case PieceType.TRANSFER_WORKFLOW:
                case PieceType.GROUP:
                case PieceType.GROUP_FOR_LIST:
                case PieceType.GROUPED_QUESTION:
                case PieceType.CHOOSE:
                case PieceType.GROUPED_CHOOSE:
                case PieceType.GROUPED_SHOW:
                case PieceType.REPEAT:
                case PieceType.ADD_MEMBER:
                case PieceType.ADD_GROUP:
                case PieceType.ADD_WORKFLOW:
                case PieceType.ADD_REPORT:
                case PieceType.SET_MEMBERS_IN_GROUP:
                case PieceType.SECTION:
                case PieceType.ADD_TO_LIST:
                case PieceType.REMOVE_FROM_LIST:
                case PieceType.ADD_TO_TABLE:
                case PieceType.NEW_DATE:
                case PieceType.RESTRICT_NAVIGATION:
                case PieceType.CONTINUE:
                case PieceType.ARCHIVE:
                case PieceType.GET_CURRENT_LOCATION:
                case PieceType.SET_LOCATION:
                    newPieceData.nextPiece = action.value;
                    newPieceData.lastUpdatedTime = action.updateTime;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceData
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }
        
        case SET_INNER_PIECE:

            newPieceData = {
                ...state.byId[action.pieceId]
            };

            switch (newPieceData.type) {
                case PieceType.FOR:
                case PieceType.GROUP:
                case PieceType.GROUP_FOR_LIST:
                case PieceType.QUESTION:
                case PieceType.GROUPED_QUESTION:
                case PieceType.CHOOSE:
                case PieceType.GROUPED_CHOOSE:
                case PieceType.SECTION:
                    newPieceData.innerPiece = action.value;
                    newPieceData.lastUpdatedTime = action.updateTime;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceData
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }

        case SET_CONDITION_PIECES:
            newPieceData = {
                ...state.byId[action.pieceId],
            };

            switch (newPieceData.type) {
                case PieceType.SPLIT:
                    newPieceData.ifPieceData = action.value;
                    newPieceData.lastUpdatedTime = action.updateTime;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceData
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            };
        
        case SET_CONDITION_PIECE:

            newPieceData = {
                ...state.byId[action.pieceId]
            };

            switch (newPieceData.type) {
                case PieceType.SPLIT:
                    newPieceData.ifPieceData = newPieceData.ifPieceData ? newPieceData.ifPieceData.map((ifPiece, index) => {
                        if (index === action.ifIndex) {
                            return {
                                ...ifPiece,
                                conditionPiece: action.value,
                            };
                        } else {
                            return ifPiece;
                        }
                    }) : [];
                    newPieceData.lastUpdatedTime = action.updateTime;
                    break;
                case PieceType.CONTINUE:
                    newPieceData.condition = action.value;
                    newPieceData.lastUpdatedTime = action.updateTime;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceData
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            };
        
        case SET_CONDITION_PIECE_POSITION:

                newPieceData = {
                    ...state.byId[action.pieceId]
                };

                switch (newPieceData.type) {
                    case PieceType.SPLIT:
                        newPieceData.ifPieceData = newPieceData.ifPieceData ? newPieceData.ifPieceData.map((ifPiece, index) => {
                            if (index === action.ifIndex) {
                                return {
                                    ...ifPiece,
                                    x: action.x,
                                    y: action.y,
                                };
                            } else {
                                return ifPiece;
                            }
                        }) : [];
                        newPieceData.lastUpdatedTime = action.updateTime;
                        break;
                    default:
                        break;
                }
    
                return {
                    ...state,
                    byId: {
                        ...state.byId,
                        [action.pieceId]: {
                            ...newPieceData
                        }
                    },
                    updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
                }
        
        case SET_CONDITION_NEXT_PIECE:

                newPieceData = {
                    ...state.byId[action.pieceId]
                };

                switch (newPieceData.type) {
                    case PieceType.SPLIT:
                        newPieceData.ifPieceData = newPieceData.ifPieceData ? newPieceData.ifPieceData.map((ifPiece, index) => {
                            if (index === action.ifIndex) {
                                return {
                                    ...ifPiece,
                                    nextPiece: action.value,
                                };
                            } else {
                                return {
                                    ...ifPiece
                                };
                            }
                        }) : [];
                        newPieceData.lastUpdatedTime = action.updateTime;
                        break;
                    default:
                        break;
                }
    
                return {
                    ...state,
                    byId: {
                        ...state.byId,
                        [action.pieceId]: {
                            ...newPieceData
                        }
                    },
                    updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
                }
        
        case SET_LOOP_VARIABLE:

            newPieceData = {
                ...state.byId[action.pieceId]
            };

            switch (newPieceData.type) {
                case PieceType.FOR:
                case PieceType.GROUP_FOR_LIST:
                    newPieceData.loopVariable = action.value;
                    newPieceData.lastUpdatedTime = action.updateTime;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceData
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }
        
        case SET_ITERABLE_VARIABLE:

            newPieceData = {
                ...state.byId[action.pieceId]
            };

            switch (newPieceData.type) {
                case PieceType.FOR:
                case PieceType.GROUP_FOR_LIST:
                case PieceType.SET_MEMBERS_IN_GROUP:
                    newPieceData.iterableVariable = action.value;
                    newPieceData.lastUpdatedTime = action.updateTime;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceData
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }

        case SET_LOCATION_PIECE:

            newPieceData = {
                ...state.byId[action.pieceId]
            };

            switch (newPieceData.type) {
                case PieceType.ADD_MEMBER:
                case PieceType.ADD_GROUP:
                    newPieceData.locationPiece = action.location;
                    newPieceData.lastUpdatedTime = action.updateTime;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceData
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }
        
        case SET_OPERAND:

            newPieceData = {
                ...state.byId[action.pieceId]
            };

            switch (newPieceData.type) {
                case PieceType.NOT:
                case PieceType.VARIABLE_TO_BOOLEAN:
                case PieceType.BOOLEAN_TO_VARIABLE:
                case PieceType.PICK_FIRST_ELEMENT:
                case PieceType.PICK_LAST_ELEMENT:
                case PieceType.IS_DEFINED:
                case PieceType.IS_NOT_DEFINED:
                case PieceType.LENGTH:
                case PieceType.TRANSLATE:
                case PieceType.GET_DATE:
                case PieceType.GET_DAY:
                case PieceType.GET_MONTH:
                case PieceType.GET_READABLE_MONTH:
                case PieceType.GET_YEAR:
                    newPieceData.operand = action.value;
                    newPieceData.lastUpdatedTime = action.updateTime;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceData
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }
        
        case SET_LEFT_OPERAND:

            newPieceData = {
                ...state.byId[action.pieceId]
            };

            switch (newPieceData.type) {
                case PieceType.ADD:
                case PieceType.SUBTRACT:
                case PieceType.MULTIPLY:
                case PieceType.DIVIDE:
                case PieceType.EXPONENT:
                case PieceType.LESSER_THAN:
                case PieceType.LESSER_THAN_OR_EQUAL_TO:
                case PieceType.GREATER_THAN:
                case PieceType.GREATER_THAN_OR_EQUAL_TO:
                case PieceType.EQUAL_TO:
                case PieceType.NOT_EQUAL_TO:
                case PieceType.IN:
                case PieceType.NOT_IN:
                case PieceType.AND:
                case PieceType.OR:
                case PieceType.PICK_FIRST_N_ELEMENTS:
                case PieceType.PICK_LAST_N_ELEMENTS:
                case PieceType.PICK_NTH_ELEMENT:
                case PieceType.ADD_MONTHS:
                case PieceType.ADD_YEARS:
                case PieceType.SUBTRACT_MONTHS:
                case PieceType.SUBTRACT_YEARS:
                case PieceType.GET_TIME_DIFFERENCE:
                    newPieceData.leftOperand = action.value;
                    newPieceData.lastUpdatedTime = action.updateTime;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceData
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }
        
        case SET_RIGHT_OPERAND:

            newPieceData = {
                ...state.byId[action.pieceId]
            };

            switch (newPieceData.type) {
                case PieceType.ADD:
                case PieceType.SUBTRACT:
                case PieceType.MULTIPLY:
                case PieceType.DIVIDE:
                case PieceType.EXPONENT:
                case PieceType.LESSER_THAN:
                case PieceType.LESSER_THAN_OR_EQUAL_TO:
                case PieceType.GREATER_THAN:
                case PieceType.GREATER_THAN_OR_EQUAL_TO:
                case PieceType.EQUAL_TO:
                case PieceType.NOT_EQUAL_TO:
                case PieceType.IN:
                case PieceType.NOT_IN:
                case PieceType.AND:
                case PieceType.OR:
                case PieceType.PICK_FIRST_N_ELEMENTS:
                case PieceType.PICK_LAST_N_ELEMENTS:
                case PieceType.PICK_NTH_ELEMENT:
                case PieceType.ADD_MONTHS:
                case PieceType.ADD_YEARS:
                case PieceType.SUBTRACT_MONTHS:
                case PieceType.SUBTRACT_YEARS:
                case PieceType.GET_TIME_DIFFERENCE:
                    newPieceData.rightOperand = action.value;
                    newPieceData.lastUpdatedTime = action.updateTime;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceData
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }

        case SET_VARIABLE_FOR_LIST:

            newPieceData = {
                ...state.byId[action.pieceId]
            };

            switch (newPieceData.type) {
                case PieceType.ADD_TO_LIST:
                case PieceType.REMOVE_FROM_LIST:
                case PieceType.ADD_TO_TABLE:
                    newPieceData.listVariable = action.variable;
                    newPieceData.lastUpdatedTime = action.updateTime;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceData
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }

        case SET_VARIABLE_FOR_NEW_DATE:

            newPieceData = {
                ...state.byId[action.pieceId]
            };

            switch (newPieceData.type) {
                case PieceType.NEW_DATE:
                    newPieceData.variablePiece = action.value;
                    newPieceData.lastUpdatedTime = action.updateTime;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceData
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }

        case SET_PIECE_FOR_LIST:

            newPieceData = {
                ...state.byId[action.pieceId]
            };

            switch (newPieceData.type) {
                case PieceType.ADD_TO_LIST:
                case PieceType.REMOVE_FROM_LIST:
                case PieceType.ADD_TO_TABLE:
                    newPieceData.dataToSet = action.dataToSet;
                    newPieceData.lastUpdatedTime = action.updateTime;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceData
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }
        
        case SET_QUESTION_DATA:

            newPieceData = {
                ...state.byId[action.pieceId]
            };

            switch (newPieceData.type) {
                case PieceType.QUESTION:
                case PieceType.GROUPED_QUESTION:
                case PieceType.CHOOSE:
                case PieceType.GROUPED_CHOOSE:
                    newPieceData.question = action.value;
                    newPieceData.lastUpdatedTime = action.updateTime;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceData
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }
        
        case SET_QUESTION_REQUIRED_PIECE:

            newPieceData = {
                ...state.byId[action.pieceId]
            };

            switch (newPieceData.type) {
                case PieceType.QUESTION:
                case PieceType.GROUPED_QUESTION:
                case PieceType.CHOOSE:
                case PieceType.GROUPED_CHOOSE:
                    newPieceData.isRequiredPiece = action.value;
                    newPieceData.lastUpdatedTime = action.updateTime;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceData
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }
        
        case SET_QUESTION_DISABLED_PIECE:

            newPieceData = {
                ...state.byId[action.pieceId]
            };

            switch (newPieceData.type) {
                case PieceType.QUESTION:
                case PieceType.GROUPED_QUESTION:
                case PieceType.CHOOSE:
                case PieceType.GROUPED_CHOOSE:
                    newPieceData.isDisabledPiece = action.value;
                    newPieceData.lastUpdatedTime = action.updateTime;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceData
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }
        
        case SET_QUESTION_DEFAULT_PIECE:

            newPieceData = {
                ...state.byId[action.pieceId]
            };

            switch (newPieceData.type) {
                case PieceType.QUESTION:
                case PieceType.GROUPED_QUESTION:
                case PieceType.CHOOSE:
                case PieceType.GROUPED_CHOOSE:
                    newPieceData.default = action.value;
                    newPieceData.lastUpdatedTime = action.updateTime;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceData
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }
        
        case SET_QUESTION_IMAGE:

            newPieceData = {
                ...state.byId[action.pieceId]
            };

            switch (newPieceData.type) {
                case PieceType.QUESTION:
                case PieceType.GROUPED_QUESTION:
                    newPieceData.image = action.value;
                    newPieceData.lastUpdatedTime = action.updateTime;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceData
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }
        
        case SET_CUSTOM_FIELD:

            newPieceData = {
                ...state.byId[action.pieceId]
            };

            switch (newPieceData.type) {
                case PieceType.GET:
                case PieceType.GET_VALUE:
                case PieceType.STORE:
                case PieceType.QUESTION:
                case PieceType.GROUPED_QUESTION:
                    newPieceData.customFieldId = action.value;
                    newPieceData.lastUpdatedTime = action.updateTime;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceData
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }

        case SET_VARIABLE_FOR_SET:

            newPieceData = {
                ...state.byId[action.pieceId]
            };

            switch (newPieceData.type) {
                case PieceType.SET_VARIABLE:
                    newPieceData.variableToSet = action.value;
                    newPieceData.lastUpdatedTime = action.updateTime;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceData
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }

        case SET_VARIABLE_FOR_CURRENT_LOCATION:

            newPieceData = {
                ...state.byId[action.pieceId]
            };

            switch (newPieceData.type) {
                case PieceType.GET_CURRENT_LOCATION:
                    newPieceData.variable = action.value;
                    newPieceData.lastUpdatedTime = action.updateTime;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceData
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }

        case SET_VARIABLE_FOR_ADD_MEMBER:

            newPieceData = {
                ...state.byId[action.pieceId]
            };

            switch (newPieceData.type) {
                case PieceType.ADD_MEMBER:
                    newPieceData.variable = action.variable;
                    newPieceData.lastUpdatedTime = action.updateTime;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceData
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }

        case SET_VARIABLE_FOR_ADD_GROUP:

            newPieceData = {
                ...state.byId[action.pieceId]
            };

            switch (newPieceData.type) {
                case PieceType.ADD_GROUP:
                    newPieceData.variable = action.variable;
                    newPieceData.lastUpdatedTime = action.updateTime;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceData
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }

        case SET_VARIABLE_FOR_ADD_WORKFLOW:

            newPieceData = {
                ...state.byId[action.pieceId]
            };

            switch (newPieceData.type) {
                case PieceType.ADD_WORKFLOW:
                    newPieceData.variable = action.variable;
                    newPieceData.lastUpdatedTime = action.updateTime;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceData
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }

        case SET_VARIABLE_FOR_ADD_REPORT:

            newPieceData = {
                ...state.byId[action.pieceId]
            };

            switch (newPieceData.type) {
                case PieceType.ADD_REPORT:
                    newPieceData.variable = action.variable;
                    newPieceData.lastUpdatedTime = action.updateTime;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceData
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }

        case SET_HEADING:

            newPieceData = {
                ...state.byId[action.pieceId]
            };

            switch (newPieceData.type) {
                case PieceType.SECTION:
                case PieceType.GROUP:
                case PieceType.GROUP_FOR_LIST:
                    newPieceData.heading = action.value;
                    newPieceData.lastUpdatedTime = action.updateTime;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceData
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }

        case SET_COLUMNS:

            newPieceData = {
                ...state.byId[action.pieceId]
            };

            switch (newPieceData.type) {
                case PieceType.SECTION:
                    newPieceData.columns = action.value;
                    newPieceData.lastUpdatedTime = action.updateTime;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceData
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }

        case SET_STRUCTURE_PROJECT:

            newPieceData = {
                ...state.byId[action.pieceId]
            };

            switch (newPieceData.type) {
                case PieceType.STRUCTURE:
                    newPieceData.project = action.project;
                    newPieceData.lastUpdatedTime = action.updateTime;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceData
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }

        case SET_STRUCTURE_LEVEL:

            newPieceData = {
                ...state.byId[action.pieceId]
            };

            switch (newPieceData.type) {
                case PieceType.STRUCTURE:
                    newPieceData.level = action.level;
                    newPieceData.lastUpdatedTime = action.updateTime;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceData
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }

        case SET_STRUCTURE_ROLE:

            newPieceData = {
                ...state.byId[action.pieceId]
            };

            switch (newPieceData.type) {
                case PieceType.STRUCTURE:
                    newPieceData.role = action.role;
                    newPieceData.lastUpdatedTime = action.updateTime;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceData
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }

        case SET_STATIC_DATA_HOLDER:

            newPieceData = {
                ...state.byId[action.pieceId]
            };

            switch (newPieceData.type) {
                case PieceType.STATIC_DATA:
                    newPieceData.staticDataHolder = action.staticData;
                    newPieceData.selectedFragments = undefined;
                    newPieceData.lastUpdatedTime = action.updateTime;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceData
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }

        case SET_DATA_FRAGMENTS:

            newPieceData = {
                ...state.byId[action.pieceId]
            };

            switch (newPieceData.type) {
                case PieceType.STATIC_DATA:
                    newPieceData.selectedFragments = action.dataFragments;
                    newPieceData.lastUpdatedTime = action.updateTime;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceData
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }

        case SET_MEMBERS_TYPE_IN_GROUP:

            newPieceData = {
                ...state.byId[action.pieceId]
            };

            switch (newPieceData.type) {
                case PieceType.SET_MEMBERS_IN_GROUP:
                    newPieceData.memberType = action.value;
                    newPieceData.lastUpdatedTime = action.updateTime;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceData
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }

        case SET_QUESTION_CHOICE_VARIABLE:

            newPieceData = {
                ...state.byId[action.pieceId]
            };

            switch (newPieceData.type) {
                case PieceType.CHOOSE:
                case PieceType.GROUPED_CHOOSE:
                    newPieceData.choiceVariable = action.value;
                    newPieceData.lastUpdatedTime = action.updateTime;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceData
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }
        
        case SET_MEMBER_VARIABLE:

            newPieceData = {
                ...state.byId[action.pieceId]
            };

            switch (newPieceData.type) {
                case PieceType.QUESTION:
                case PieceType.GROUPED_QUESTION:
                case PieceType.GROUPED_ANSWER:
                case PieceType.CUSTOM_FIELD:
                case PieceType.GET:
                case PieceType.GET_VALUE:
                case PieceType.STORE:
                    newPieceData.memberVariablePiece = action.value;
                    newPieceData.lastUpdatedTime = action.updateTime;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceData
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }
        
        case SET_DATA_STORE_VALUE:

            newPieceData = {
                ...state.byId[action.pieceId]
            };

            switch (newPieceData.type) {
                case PieceType.STORE:
                    newPieceData.dataToStore = action.value;
                    newPieceData.lastUpdatedTime = action.updateTime;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceData
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }
        
        case SET_DATA_SET_VALUE:

            newPieceData = {
                ...state.byId[action.pieceId]
            };

            switch (newPieceData.type) {
                case PieceType.SET_VARIABLE:
                    newPieceData.dataToSet = action.value;
                    newPieceData.lastUpdatedTime = action.updateTime;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceData
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }
        
        case SET_DATA_COPY_VARIABLE:

            newPieceData = {
                ...state.byId[action.pieceId]
            };

            switch (newPieceData.type) {
                case PieceType.GET:
                    newPieceData.variableToCopy = action.value;
                    newPieceData.lastUpdatedTime = action.updateTime;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceData
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }
        
        case SET_RETURN_VALUE:

            newPieceData = {
                ...state.byId[action.pieceId]
            };

            switch (newPieceData.type) {
                case PieceType.RETURN:
                case PieceType.RETURN_RICH_TEXT:
                    newPieceData.returnValue = action.value;
                    newPieceData.lastUpdatedTime = action.updateTime;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceData
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }
        
        case SET_ERROR:

            newPieceData = {
                ...state.byId[action.pieceId]
            };

            switch (newPieceData.type) {
                case PieceType.ERROR:
                    newPieceData.error = action.error;
                    newPieceData.lastUpdatedTime = action.updateTime;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceData
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }
        
        case SET_MESSAGE:

            newPieceData = {
                ...state.byId[action.pieceId]
            };

            switch (newPieceData.type) {
                case PieceType.END:
                    newPieceData.message = action.message;
                    newPieceData.lastUpdatedTime = action.updateTime;
                    break;
                case PieceType.CONTINUE:
                    newPieceData.message = action.message;
                    newPieceData.lastUpdatedTime = action.updateTime;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceData
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }

        case SET_UPDATE_STATUS_VALUE:

            newPieceData = {
                ...state.byId[action.pieceId]
            };

            switch (newPieceData.type) {
                case PieceType.UPDATE_STATUS:
                case PieceType.END:
                    newPieceData.status = action.value;
                    newPieceData.lastUpdatedTime = action.updateTime;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceData,
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }

        case SET_UPDATE_DUE_DATE_VALUE:

            newPieceData = {
                ...state.byId[action.pieceId]
            };

            switch (newPieceData.type) {
                case PieceType.UPDATE_DUE_DATE:
                    newPieceData.dueDate = action.value;
                    newPieceData.lastUpdatedTime = action.updateTime;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceData,
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }

        case SET_SELECTED_OPTIONS:

            newPieceData = {
                ...state.byId[action.pieceId]
            };

            switch (newPieceData.type) {
                case PieceType.SEQUENCE:
                    newPieceData.selectedOptions = action.value;
                    newPieceData.lastUpdatedTime = action.updateTime;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceData,
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }

        case SET_VARIABLE_FOR_SHOW:

            newPieceData = {
                ...state.byId[action.pieceId]
            };

            switch (newPieceData.type) {
                case PieceType.SHOW:
                case PieceType.GROUPED_SHOW:
                    newPieceData.variableToShow = action.value;
                    newPieceData.entityType = undefined;
                    newPieceData.customFieldIds = undefined;
                    newPieceData.startingDisplayType = undefined;
                    newPieceData.xAxis = undefined;
                    newPieceData.yAxis = undefined;
                    newPieceData.yAxisAggregation = undefined;
                    newPieceData.lastUpdatedTime = action.updateTime;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceData,
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }

        case SET_WIDGET_TITLE_FOR_SHOW:

            newPieceData = {
                ...state.byId[action.pieceId]
            };

            switch (newPieceData.type) {
                case PieceType.SHOW:
                case PieceType.GROUPED_SHOW:
                    newPieceData.widgetTitle = action.value;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceData,
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }

        case SET_STARTING_DISPLAY_FOR_SHOW:

            newPieceData = {
                ...state.byId[action.pieceId]
            };

            switch (newPieceData.type) {
                case PieceType.SHOW:
                case PieceType.GROUPED_SHOW:
                    newPieceData.startingDisplayType = action.value;
                    newPieceData.customFieldIds = undefined;
                    newPieceData.xAxis = undefined;
                    newPieceData.yAxis = undefined;
                    newPieceData.yAxisAggregation = undefined;
                    newPieceData.lastUpdatedTime = action.updateTime;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceData,
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }

        case SET_X_AXIS_FOR_SHOW:

            newPieceData = {
                ...state.byId[action.pieceId]
            };

            switch (newPieceData.type) {
                case PieceType.SHOW:
                case PieceType.GROUPED_SHOW:
                    newPieceData.xAxis = action.value;
                    newPieceData.lastUpdatedTime = action.updateTime;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceData,
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }

        case SET_Y_AXIS_AGGREGATION_FOR_SHOW:

            newPieceData = {
                ...state.byId[action.pieceId]
            };

            switch (newPieceData.type) {
                case PieceType.SHOW:
                case PieceType.GROUPED_SHOW:
                    newPieceData.yAxisAggregation = action.value;
                    newPieceData.yAxis = undefined;
                    newPieceData.lastUpdatedTime = action.updateTime;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceData,
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }

        case SET_Y_AXIS_FOR_SHOW:

            newPieceData = {
                ...state.byId[action.pieceId]
            };

            switch (newPieceData.type) {
                case PieceType.SHOW:
                case PieceType.GROUPED_SHOW:
                    newPieceData.yAxis = action.value;
                    newPieceData.lastUpdatedTime = action.updateTime;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceData,
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }

        case SET_RICH_TEXT_FOR_SHOW:

            newPieceData = {
                ...state.byId[action.pieceId]
            };

            switch (newPieceData.type) {
                case PieceType.SHOW:
                case PieceType.GROUPED_SHOW:
                    newPieceData.isRichText = action.value;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceData,
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }

        case SET_FORMAT_MODIFIER:

            newPieceData = {
                ...state.byId[action.pieceId]
            };

            switch (newPieceData.type) {
                case PieceType.FORMAT:
                    newPieceData.formatModifier = action.formatModifier;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceData,
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }

        case SET_TIME_DIFFERENCE_FORMAT:

            newPieceData = {
                ...state.byId[action.pieceId]
            };

            switch (newPieceData.type) {
                case PieceType.GET_TIME_DIFFERENCE:
                    newPieceData.format = action.format;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceData,
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }

        case SET_VARIABLE_PIECE:

            newPieceData = {
                ...state.byId[action.pieceId]
            };

            switch (newPieceData.type) {
                case PieceType.CHOOSE:
                case PieceType.GROUPED_CHOOSE:
                case PieceType.SET_MEMBERS_IN_GROUP:
                case PieceType.SWITCH_WORKFLOW:
                case PieceType.NEW_DATE:
                case PieceType.ARCHIVE:
                case PieceType.FORMAT:
                case PieceType.GET_AFFILIATION_FROM_WORKFLOW:
                case PieceType.SET_LOCATION:
                    newPieceData.variablePiece = action.variablePiece;
                    newPieceData.lastUpdatedTime = action.updateTime;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceData,
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }

        case SET_VARIABLE_FOR_CUSTOM_FIELD:

            newPieceData = {
                ...state.byId[action.pieceId]
            };

            switch (newPieceData.type) {
                case PieceType.GET:
                case PieceType.GET_VALUE:
                case PieceType.STORE:
                    newPieceData.variablePiece = action.value;
                    newPieceData.entityType = undefined;
                    newPieceData.customFieldId = undefined;
                    newPieceData.lastUpdatedTime = action.updateTime;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceData,
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }

        case SET_ENTITY:

            newPieceData = {
                ...state.byId[action.pieceId]
            };

            switch (newPieceData.type) {
                case PieceType.GET_ENTITIES:
                    newPieceData.entity = action.value;
                    newPieceData.entityType = undefined;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceData,
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }

        case SET_ENTITY_TYPE:

            newPieceData = {
                ...state.byId[action.pieceId]
            };

            switch (newPieceData.type) {
                case PieceType.SHOW:
                case PieceType.GROUPED_SHOW:
                    newPieceData.entityType = action.value;
                    newPieceData.customFieldIds = undefined;
                    newPieceData.startingDisplayType = undefined;
                    newPieceData.xAxis = undefined;
                    newPieceData.yAxis = undefined;
                    newPieceData.yAxisAggregation = undefined;
                    newPieceData.lastUpdatedTime = action.updateTime;
                    break;
                case PieceType.GET:
                case PieceType.GET_VALUE:
                case PieceType.STORE:
                    newPieceData.entityType = action.value;
                    newPieceData.customFieldId = undefined;
                    newPieceData.lastUpdatedTime = action.updateTime;
                    break;
                case PieceType.ADD_MEMBER:
                case PieceType.ADD_GROUP:
                    newPieceData.entityType = action.value;
                    newPieceData.lastUpdatedTime = action.updateTime;
                    break;
                case PieceType.GET_ENTITIES:
                    newPieceData.entityType = action.value;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceData,
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }

        case SET_CUSTOM_FIELDS_FOR_SHOW:

            newPieceData = {
                ...state.byId[action.pieceId]
            };

            switch (newPieceData.type) {
                case PieceType.SHOW:
                case PieceType.GROUPED_SHOW:
                    newPieceData.customFieldIds = action.value;
                    newPieceData.lastUpdatedTime = action.updateTime;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceData,
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }

        case SET_TRANSFER_ROLES:

            newPieceData = {
                ...state.byId[action.pieceId]
            };

            switch (newPieceData.type) {
                case PieceType.TRANSFER_WORKFLOW:
                    newPieceData.roles = action.roles;
                    newPieceData.lastUpdatedTime = action.updateTime;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceData,
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }

        case START_PIECE_DRAG:

            return {
                ...state,
                isDragging: true,
                lastDraggedPiece: action.pieceId,
            }

        case STOP_PIECE_DRAG:
            
            return {
                ...state,
                isDragging: false,
            }

        case SET_TARGET_PIECE:

            return {
                ...state,
                targetPiece: action.pieceId,
            }

        case UPDATE_CUSTOM_FIELD_PIECE:

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...state.byId[action.pieceId],
                        type: PieceType.CUSTOM_FIELD,
                        customField: action.customField,
                        customFieldOption: action.customFieldOption,
                        lastUpdatedTime: action.updateTime,
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }

        case UPDATE_ANSWER_PIECE:

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...state.byId[action.pieceId],
                        type: PieceType.GROUPED_ANSWER,
                        customField: action.customField,
                        lastUpdatedTime: action.updateTime,
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }

        case UPDATE_STATUS_PIECE:

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...state.byId[action.pieceId],
                        type: PieceType.STATUS,
                        statusId: action.statusId,
                        lastUpdatedTime: action.updateTime,
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }

        case UPDATE_VARIABLE_PIECE:

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...state.byId[action.pieceId],
                        type: PieceType.VARIABLE,
                        variable: action.variable,
                        nesting: action.nesting,
                        lastUpdatedTime: action.updateTime,
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }

        case SET_YEAR:

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...state.byId[action.pieceId],
                        type: PieceType.NEW_DATE,
                        yearVariablePiece: action.value,
                        lastUpdatedTime: action.updateTime,
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }

        case SET_MONTH:

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...state.byId[action.pieceId],
                        type: PieceType.NEW_DATE,
                        monthVariablePiece: action.value,
                        lastUpdatedTime: action.updateTime,
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }

        case SET_DATE:

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...state.byId[action.pieceId],
                        type: PieceType.NEW_DATE,
                        dateVariablePiece: action.value,
                        lastUpdatedTime: action.updateTime,
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }

        case SET_WORKFLOW:

            newPieceData = {
                ...state.byId[action.pieceId]
            };

            switch (newPieceData.type) {
                case PieceType.UPDATE_STATUS:
                case PieceType.UPDATE_DUE_DATE:
                case PieceType.END:
                    newPieceData.workflow = action.workflow;
                    newPieceData.lastUpdatedTime = action.updateTime;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceData,
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }

        case SET_WORKFLOW_TYPE:

            newPieceData = {
                ...state.byId[action.pieceId]
            };

            switch (newPieceData.type) {
                case PieceType.ADD_WORKFLOW:
                case PieceType.UPDATE_STATUS:
                case PieceType.START_WORKFLOW:
                case PieceType.GET_AFFILIATION_FROM_WORKFLOW:
                    newPieceData.workflowType = action.workflowType;
                    newPieceData.lastUpdatedTime = action.updateTime;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceData,
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }

        case SET_WORKFLOW_STATUS:

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...state.byId[action.pieceId],
                        type: PieceType.START_WORKFLOW,
                        workflowStatus: action.status,
                        lastUpdatedTime: action.updateTime,
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }

        case SET_WORKFLOW_DUE_DATE:

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...state.byId[action.pieceId],
                        type: PieceType.START_WORKFLOW,
                        workflowDueDateVariable: action.dueDate,
                        lastUpdatedTime: action.updateTime,
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }

        case SET_WORKFLOW_SHOW_ERRORS:

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...state.byId[action.pieceId],
                        type: PieceType.ADD_WORKFLOW,
                        showWorkflowShowErrors: action.shouldShowErrors,
                        lastUpdatedTime: action.updateTime,
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }

        case SET_WORKFLOW_AFFILIATION_VARIABLE:

            newPieceData = {
                ...state.byId[action.pieceId]
            };

            switch (newPieceData.type) {
                case PieceType.ADD_WORKFLOW:
                case PieceType.START_WORKFLOW:
                case PieceType.SET_LOCATION:
                    newPieceData.affiliationVariable = action.affiliationVariable;
                    newPieceData.lastUpdatedTime = action.updateTime;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceData,
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }

        case SET_WORKFLOW_IS_ASYNC:

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...state.byId[action.pieceId],
                        type: PieceType.START_WORKFLOW,
                        isAsync: action.isAsync,
                        lastUpdatedTime: action.updateTime,
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }

        case SET_REPORT_NAME:

            newPieceData = {
                ...state.byId[action.pieceId]
            };

            switch (newPieceData.type) {
                case PieceType.ADD_REPORT:
                    newPieceData.name = action.name;
                    newPieceData.lastUpdatedTime = action.updateTime;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceData,
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }

        case SET_REPORT_TYPE:

            newPieceData = {
                ...state.byId[action.pieceId]
            };

            switch (newPieceData.type) {
                case PieceType.ADD_REPORT:
                    newPieceData.reportType = action.reportType;
                    newPieceData.lastUpdatedTime = action.updateTime;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceData,
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }

        case SET_REPORT_USER:

            newPieceData = {
                ...state.byId[action.pieceId]
            };

            switch (newPieceData.type) {
                case PieceType.ADD_REPORT:
                    newPieceData.user = action.user;
                    newPieceData.lastUpdatedTime = action.updateTime;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceData,
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }

        case SET_REPORT_START_DATE:

            newPieceData = {
                ...state.byId[action.pieceId]
            };

            switch (newPieceData.type) {
                case PieceType.ADD_REPORT:
                    newPieceData.startDate = action.startDate;
                    newPieceData.lastUpdatedTime = action.updateTime;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceData,
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }

        case SET_REPORT_END_DATE:

            newPieceData = {
                ...state.byId[action.pieceId]
            };

            switch (newPieceData.type) {
                case PieceType.ADD_REPORT:
                    newPieceData.endDate = action.endDate;
                    newPieceData.lastUpdatedTime = action.updateTime;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceData,
                    }
                },
                updatedIds: !state.createdIds.has(action.pieceId) ? new Set(Array.from(state.updatedIds).concat([action.pieceId])) : state.updatedIds,
            }

        case ADD_PIECE:
            const newPieceType = {
                id: action.pieceId,
                type: action.pieceType,
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceId]: {
                        ...newPieceType,
                        createdTime: action.createdTime,
                        lastUpdatedTime: action.createdTime,
                    } as AllPieceTypes
                },
                allEntries: state.allEntries.concat([action.pieceId]),
                createdIds: new Set(Array.from(state.createdIds).concat([action.pieceId])),
            }

        case ADD_FULL_PIECE:
            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.pieceData.id]: action.pieceData
                },
                allEntries: state.allEntries.concat([action.pieceData.id]),
                createdIds: new Set(Array.from(state.createdIds).concat([action.pieceData.id])),
            }
        
        case ADD_FULL_PIECES:
            state = {
                ...state,
                byId: {
                    ...state.byId,
                },
                allEntries: state.allEntries.slice(),
                createdIds: new Set(Array.from(state.createdIds)),
            };

            for (const newPiece of action.piecesData) {
                state.byId[newPiece.id] = newPiece;
                state.allEntries.push(newPiece.id);
                state.createdIds.add(newPiece.id);
            }

            return state;

        case DELETE_PIECE:
            const newState = {
                ...state,
                byId: {
                    ...state.byId,
                },
                allEntries: state.allEntries.filter(pieceId => pieceId !== action.pieceId),
                deletedIds: new Set(Array.from(state.updatedIds).concat([action.pieceId])),
                selected: undefined,
                lastDraggedPiece: undefined,
            }

            delete newState.byId[action.pieceId];

            return newState;

        case COPY_PIECE:
            return {
                ...state,
                lastCopiedPiece: action.pieceId,
            };

        case SHOW_RICH_TEXT_EDITOR:
            return {
                ...state,
                isShowingRichTextEditor: true,
            };

        case HIDE_RICH_TEXT_EDITOR:
            return {
                ...state,
                isShowingRichTextEditor: false,
            };

        case UPDATE_PIECES_DATA:
            return updateEntries<PieceState, IPiece>(state, action.data);

        case SYNCHRONIZE_PIECES_DATA:
            return synchronizeEntries<PieceState, IPiece>(state, action.data);

        case CLEAR_PIECES_DELTA:
            return clearDelta<PieceState, IPiece>(state);

        // Flowchart actions

        case UPDATE_FLOWCHART_DATA:
            return {
                ...action.data.pieces,
                createdIds: state.createdIds,
                updatedIds: state.updatedIds,
                deletedIds: state.deletedIds,
            }
            
        default: return state;
    }
}